import { render, staticRenderFns } from "./ComQuestionMode.vue?vue&type=template&id=10dc76c7&scoped=true&"
import script from "./ComQuestionMode.vue?vue&type=script&lang=js&"
export * from "./ComQuestionMode.vue?vue&type=script&lang=js&"
import style0 from "./ComQuestionMode.vue?vue&type=style&index=0&id=10dc76c7&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10dc76c7",
  null
  
)

export default component.exports